module.exports = __webpack_public_path__ + "img/logo.53f52717.png";